module.exports = __webpack_public_path__ + "media/media/service/wrestling-1f4bcd1cad7b150196bee28085c37d4d.svg";